import { ProjectSubmission } from "@/javascript/project-objects";
import { Box, Group, Skeleton } from '@mantine/core';
import React from "react";
import VideoBlock from "./VideoBlock";


interface VideoGridProps {
	videos: ProjectSubmission[] | null | undefined;
	skeletonSize: number
}

const VideoGrid: React.FC<VideoGridProps> = ({ videos, skeletonSize }) => {
	const isLoading = !videos

	return (
		<Group
			w="100%"
			justify="center"
			style={{ margin: 0 }}
		>
			<Box
				w="100%"
				style={{
					display: "grid",
					gridTemplateColumns: "repeat(auto-fit, minmax(300px, max-content))",
					gap: "2rem",
					justifyContent: "center",
				}}
			>
				{isLoading
					? Array.from({ length: skeletonSize }).map((_, i) => (
						<Skeleton key={i} h={300} w={300} radius="md" />
					))
					: videos.map((video) => (
						<VideoBlock
							key={video.id}
							video={video}
						/>
					))}
			</Box>
		</Group>
	);
};

export default VideoGrid;